module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "adam-smith.c55c0eb9.webp";